import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  edmStyle: {
    fontFamily: "Montserrat, Noto Sans TC, Noto Sans SC, Arial, Helvetica, sans-serif !important", 
  },
  header: {
    width: "100%",
    // backgroundColor: "#243d77",
    // textAlign: "center",
    // color: "white",
    padding: "0 0 15px 0",
    display: "grid",
    // gridTemplateColumns: "50% 50%",
    gridTemplateColumns: "1 1",
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: "40% 40%",
    },
    justifyContent: "center",
    alignItems: "center",
  },
  bannerContainer: {
    position: "relative",
    backgroundImage: "url(/media/Banner.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
  },
  bannerHeader: {
    fontSize: "32px",
    fontWeight: "bold",
    textAlign: "center",
    color: "rgb(0,55,123)",
    overflowWrap: "break-word",
    margin: "auto",
    maxHeight: '300px',
    order: 2,
    whiteSpace: "no-wrap",
    padding: '20px',
    [theme.breakpoints.up('md')]: {
      order: 0,
      fontSize: "40px",
      margin: "0",
      marginLeft: "auto",
    },
  },
  bannerImg: {
    width: "100%",
    maxHeight: '300px',
    maxWidth: '783px',
  },
  bannerVerticalCenter: {
    margin: "0",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    textAlign: "center",
    width: "100%",
    fontSize: "30px",
  },
}));

export function EDMBanner({ titleKey }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <h4 className={classes.bannerHeader}>{t(`${titleKey}`)}</h4>
      <img className={classes.bannerImg} src={`${process.env.REACT_APP_ROUTER_BASE_URL}/media/Banner_pure.png`} />
    </div>
  );
}

export default EDMBanner;
